import { getProductTypes } from 'reduxpath/ducks/ProductType/List'

import { getServices } from 'reduxpath/ducks/Service/List'

import {
  getFormats,
  getServiceSelections,
} from 'reduxpath/ducks/Format/List'

import Home from 'units/CategoryManagement/units'
import List from 'units/CategoryManagement/units/List'

const list = (store) => {
  store.dispatch(
    getProductTypes({
      sort: 'createdAt ASC',
    }),
  )

  store.dispatch(
    getServices({
      limit: 10,
      sort: 'createdAt ASC',
    }),
  )

  store.dispatch(
    getFormats({
      limit: 10,
      sort: 'createdAt ASC',
    }),
  )
  store.dispatch(getServiceSelections())
}

export default {
  populate: {
    list,
  },
  components: {
    Home,
    List,
  },
}
